import { ApplicationsAPI } from "api/api/applicationsApi/applicationsApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { PostApplicationsMarathonMarkParams } from "api/api/applicationsApi/types";

export const postApplicationsMarathonMark = createAsyncThunk<
  void,
  PostApplicationsMarathonMarkParams
>(
  `applications/postApplicationsMarathonMark`,
  async ({ marathonId, ...params }, { rejectWithValue }) => {
    try {
      const data = await ApplicationsAPI.postApplicationsMarathonMark({
        marathonId,
        ...params,
      });
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while posting applications marathon mark",
          error?.response?.data
        );
        return rejectWithValue(error?.response?.data || "Unknown error");
      } else {
        console.error("Error while posting applications marathon mark", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);
